module.exports = __webpack_public_path__ + "static/media/header_mobile.14a16cb2.png";